




















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import UserProfileNameForm from '@/modules/user/components/shared/profile/UserProfileNameForm.vue'
import UserProfileMailForm from '@/modules/user/components/shared/profile/UserProfileMailForm.vue'
import UserProfilePhoneForm from '@/modules/user/components/shared/profile/UserProfilePhoneForm.vue'
import UserProfilePasswordForm from '@/modules/user/components/shared/profile/UserProfilePasswordForm.vue'
import UserProfileNotification from '@/modules/user/components/shared/profile/UserProfileNotification.vue'
import { UserProfileInfoResourceType } from '@/modules/user/models/user-resource.model'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'حساب کاربری',
    page_sub_header: 'مشاهده و ویرایش اطلاعات حساب کاربری'
  },
  metaInfo: {
    title: 'حساب کاربری'
  },
  components: {
    UserProfileNotification,
    UserProfilePasswordForm,
    UserProfilePhoneForm,
    UserProfileMailForm,
    UserProfileNameForm
  }
})
export default class Profile extends Vue {
  @Prop() profile!: UserProfileInfoResourceType
}
